import {trigger, state, style, transition, animate} from '@angular/animations';

export const enterAnimation = trigger('enterAnimation', [
  transition(':enter', [style({transform: 'translateY(-100%)', opacity: 0}), animate('200ms', style({transform: 'translateY(0)', opacity: 1}))]),
  transition(':leave', [style({transform: 'translateY(0)', opacity: 1}), animate('200ms', style({transform: 'translateY(-100%)', opacity: 0}))])
]);

export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [
    // :enter is alias to 'void => *'
    style({opacity: 0}),
    animate(300, style({opacity: 1}))
  ]),
  transition(':leave', [
    // :leave is alias to '* => void'
    animate(200, style({opacity: 0}))
  ])
]);
